/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagedetailnet3Inputs */

const en_ticketpagedetailnet3 = /** @type {(inputs: Ticketpagedetailnet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For you`)
};

const de_ticketpagedetailnet3 = /** @type {(inputs: Ticketpagedetailnet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dich`)
};

/**
* | output |
* | --- |
* | "For you" |
*
* @param {Ticketpagedetailnet3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagedetailnet3 = /** @type {((inputs?: Ticketpagedetailnet3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagedetailnet3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagedetailnet3(inputs)
	return de_ticketpagedetailnet3(inputs)
});
export { ticketpagedetailnet3 as "ticketPageDetailNet" }